import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import { MultiSelect } from "react-multi-select-component";
import { useSelector } from "react-redux";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import {
  columnsDynamicData,
} from "./KanbanData";
import SatAPI from "../../../_services/sat";
import toastService from "../../../_services/toastService";
import {
  getFilteredAvailability,
} from "../../../_helpers/calculations";
import KanbanColumn from "./KanbanColumn";
import "../../../scss/Kanban/Kanban.scss";
import KanbanModal from "./KanbanModal";

const api = SatAPI();

function Kanban() {
  const snapshot = useSelector((state) => state.snapshot.fileName);
  const [columns, setColumns] = useState([]);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingLight, setLoadingLight] = useState(false);
  const [olaAssignments, setOlaAssignments] = useState([]);
  const [taskAssignments, setTaskAssignments] = useState([]);
  //  const [parallels, setParallels] = useState([]);
  const [collegas, setCollegas] = useState([]);

  // const [originalData, setOriginalData] = useState({}); // object to store the original data in JSON strings

  // const [parameters, setParameters] = useState(null);

  // filter
  const [selectedCollegas, setSelectedCollegas] = useState(
    JSON.parse(localStorage.getItem("SAT-selectedCollegas")) || []
  );

  /*
  const getOLAAssignmentVisibility = (assignment, programmes) => {
    let match = false;

    if (programmes !== null) {
      programmes.forEach(programme => {
        if (assignment.ola.phases[0].phase.programmeID === programme.ID) {
          match = true;
        }
      });
    }

    if (programmes.length === 0) {
      match = true; // no filter on programmes => everything visible
    }

    return match;
  };

  const getTaskAssignmentVisibility = (assignment, programmes) => {
    let match = false;

    if (programmes !== null) {
      programmes.forEach(programme => {
        if (assignment.programmeID === programme.ID) {
          match = true;
        }
      });
    }

    if (programmes.length === 0) {
      match = true; // no filter on programmes => everything visible
    }

    return match;
  };
*/

  const calcVTE = (ta, ass, collega) => {
    const uniqueOlaIds = [
      ...new Set(ass.map((x) => x.olaID).filter(Boolean))
    ];

    const assignmentVTE = uniqueOlaIds.reduce((total, olaID) => {
      const vteSum = ass
        .filter((x) => x.collegaID === collega.ID && x.olaID === olaID)
        .reduce((n, { vte }) => n + vte, 0);
      return total + Math.round(vteSum * 2) / 2;
    }, 0);

    const taskAssignmentVTE = ta
      .filter((x) => x.collegaID === collega.ID)
      .reduce((n, { vte }) => n + vte, 0);

    const forfait = Math.round(
      (
        ta
          .filter((x) => x.collegaID === collega.ID)
          .reduce((n, { forfait }) => n + forfait, 0) +
        uniqueOlaIds.reduce((total, olaID) => {
          return (
            total +
            ass
              .filter((x) => x.collegaID === collega.ID && x.olaID === olaID)
              .reduce((n, { forfait }) => n + parseFloat(forfait), 0)
          );
        }, 0)
      ) * 2
    ) / 2;

    return assignmentVTE + taskAssignmentVTE + forfait;
  };

  const calcFilteredVTE = (ta, ass, collega, progr) => {
    const filteredAss = ass.filter(
      (c) =>
        c.collegaID === collega.ID &&
        progr.some(
          (x) =>
            x.programmeID ===
            (c.phase ? c.phase.programmeID : c.ola?.opo?.programmeID)
        )
    );

    const filteredTa = ta.filter(
      (c) =>
        c.collegaID === collega.ID &&
        progr.some((x) => x.programmeID === c.programmeID)
    );

    const uniqueOlaIds = [
      ...new Set(filteredAss.map((x) => x.olaID).filter(Boolean))
    ];

    const assignmentVTE = uniqueOlaIds.reduce((total, olaID) => {
      const vteSum = filteredAss
        .filter((x) => x.olaID === olaID)
        .reduce((n, { vte }) => n + vte, 0);
      return total + Math.round(vteSum * 2) / 2;
    }, 0);

    const taskAssignmentVTE = filteredTa.reduce((n, { vte }) => n + vte, 0);

    const forfait = Math.round(
      (
        filteredTa.reduce((n, { forfait }) => n + forfait, 0) +
        uniqueOlaIds.reduce((total, olaID) => {
          return (
            total +
            filteredAss
              .filter((x) => x.olaID === olaID)
              .reduce((n, { forfait }) => n + parseFloat(forfait), 0)
          );
        }, 0)
      ) * 2
    ) / 2;

    return assignmentVTE + taskAssignmentVTE + forfait;
  };

  const loadCollegas = async (blackoutLoad = true) => {
    try {
      if (blackoutLoad) setLoading(true);
      if (!blackoutLoad) setLoadingLight(true);
      const collegaResponse = await api.getCollegasWithContactHours(snapshot);

      const assignments = await api.getAssignments(snapshot);
      setOlaAssignments(assignments);

      /*
      const oposResponse = await api.getOPOs(snapshot);
      oposResponse.sort((a, b) => (b.name < a.name ? 1 : -1));
      
      
      let currentParallels = [];
      if (!snapshot) { // TEMPORARY WORKAROUND - old back-end always returns current parallels instead of parallels from snapshot
        currentParallels = await api.getParallels(snapshot);
        currentParallels.sort((a, b) => (b.mainOLA.name.localeCompare(a.mainOLA.name) || a.level - b.level) ? 1 : -1);
      }
     
      const allOLAsFromOPOS = [];
      oposResponse.forEach(opo => {
        opo.olas.forEach(ola => {
          allOLAsFromOPOS.push(ola);
        });
      });

      // TODO: improve this in new back-end!
      // Overwrite the OLA's in parallel because they don't contain OLA phases,
      // which is necessary for calculation of student numbers

      currentParallels.forEach(parallel => {
        parallel.mainOLA = allOLAsFromOPOS.find((ola) => ola.ID === parallel.mainOLAID);
        parallel.subOLA = allOLAsFromOPOS.find((ola) => ola.ID === parallel.subOLAID);
      });

      setParallels(currentParallels);
*/

      const taskAssignmentsFromAPI = await api.getTaskAssignments(snapshot);
      setTaskAssignments(taskAssignmentsFromAPI);

      /*
      setOriginalData({
        assignments: JSON.stringify(assignments),
        taskAssignments: JSON.stringify(taskAssignmentsFromAPI),
      });
      */

      //const { general, cs, ects } = await loadParameters();
      //setParameters({ general, cs, ects });

      const general = await api.getGlobalSettings(snapshot);

      console.log("Collegas: ", collegaResponse);
      console.log("Assignments: ", assignments);
      console.log("Task assignments: ", taskAssignmentsFromAPI);
      if (localStorage.getItem("SAT-typeSorting") === "firstname") {
        collegaResponse.sort((a, b) => b.firstName < a.firstName);
      } else {
        collegaResponse.sort((a, b) => b.lastName < a.lastName);
      }
      //
      let shownCollegas = []
      collegaResponse.forEach((collega) => {
        if (selectedCollegas.some(y => y.ID === collega.ID) || selectedCollegas.length === 0) {
          collega.taskAssignments = [];
          collega.olaAssignments = [];

          collega.contactHoursQ1 = collega.contactHours.contactHoursQ1;
          collega.contactHoursQ2 = collega.contactHours.contactHoursQ2;
          collega.contactHoursQ3 = collega.contactHours.contactHoursQ3;
          collega.contactHoursQ4 = collega.contactHours.contactHoursQ4;

          //collega.currentVTE = calculateRoundedCollegaVTEPreFetched(collega, assignments, taskAssignmentsFromAPI, currentParallels, assignments, general, cs, ects);



          collega.currentVTE = calcVTE(taskAssignmentsFromAPI, assignments, collega);
          console.warn(collega.initials + collega.currentVTE);

          collega.olaAssignments =
            assignments.filter((c) => c.collegaID === collega.ID) || [];
          collega.olaAssignments.sort(
            (a, b) => (b.ola || {}).name < (a.ola || {}).name
          );

          collega.taskAssignments =
            taskAssignmentsFromAPI.filter((c) => c.collegaID === collega.ID) ||
            [];
          collega.taskAssignments.sort((a, b) => b.task.name < a.task.name);



          // for filtering on programme
          collega.filteredProgrammes = JSON.parse(
            localStorage.getItem("SAT-PersonalProgrammeFilter")
          );

          collega.filteredProgrammesLength = collega.filteredProgrammes.length;
          collega.percentageAvailableFiltered = getFilteredAvailability(
            collega,
            collega.filteredProgrammes
          );
          //collega.filteredVTE = getVTEForCollegaByProgrammes(collega, collega.olaAssignments, collega.taskAssignments, currentParallels, assignments, general, cs, ects, collega.filteredProgrammes);
          collega.filteredVTE = calcFilteredVTE(
            taskAssignmentsFromAPI,
            assignments,
            collega,
            collega.filteredProgrammes
          );

          collega.olaAssignments.forEach((assignment) => {
            //assignment.show = getOLAAssignmentVisibility(assignment, collega.filteredProgrammes);
            assignment.show = collega.filteredProgrammesLength > 0 ? collega.filteredProgrammes.some(
              (x) =>
                x.programmeID ==
                (assignment.phase
                  ? assignment.phase.programmeID
                  : assignment.ola.opo.programmeID)
            ) : true;
          });

          collega.taskAssignments =
            taskAssignmentsFromAPI.filter((c) => c.collegaID === collega.ID) ||
            [];
          collega.taskAssignments.sort((a, b) => b.task.name < a.task.name);
          collega.taskAssignments.forEach((assignment) => {
            //assignment.show = getTaskAssignmentVisibility(assignment, collega.filteredProgrammes);
            assignment.show = collega.filteredProgrammesLength > 0 ? collega.filteredProgrammes.some(
              (x) => x.programmeID == assignment.programmeID
            ) : true;
          });



          // for filtering
          if (selectedCollegas.length !== 0) {
            collega.show = true;
          } else if (!(
            collega.filteredProgrammesLength > 0 &&
            collega.percentageAvailableFiltered === 0
          )) {
            collega.show = true
          }

          shownCollegas.push(collega);
        }

        // for multiselect
        collega.label = `${collega.firstName} ${collega.lastName}`;
        collega.value = collega.ID;

      });

      setCollegas(collegaResponse);

      setColumns(columnsDynamicData(shownCollegas, general));

      setLoading(false);
      setLoadingLight(false);
    } catch (error) {
      console.warn(error);
      toastService.send({ title: "An error occured", message: error });
    }
  };

  const onDragEnd = (result) => {
    if (result.reason !== "DROP") {
      return; // only on drop for now
    }

    console.log(result);
    const { destination, source, draggableId } = result;
    if (!destination || !source) {
      console.log("no destination or source", destination, source);
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      console.log("index and destination the same");
      return;
    }

    const sourceCol = columns.find(
      (c) => c.collegaID === parseInt(source.droppableId, 10)
    );

    console.warn("get source column", sourceCol);

    const task = sourceCol.taskIds.find((x) => x.id == draggableId);

    console.warn(task);

    if (task.type == "ola") {
      const assignmentStart = olaAssignments.find(
        (x) => x.ID == task.assignmentID
      );

      const assignmentEnd = {
        ID: assignmentStart.ID,
        collegaID: columns.find(
          (c) => c.collegaID === parseInt(destination.droppableId, 10)
        ).collegaID,
        comment: assignmentStart.comment,
        forceParallel: assignmentStart.forceParallel,
        internshipStudents: assignmentStart.internshipStudents,
        olaID: assignmentStart.olaID,
        opoResponsible: assignmentStart.opoResponsible,
        percentageOverride: assignmentStart.percentageOverride,
        phaseID: assignmentStart.phaseID,
      };

      //console.warn(assignmentStart, assignmentEnd);

      api.updateAssignment(assignmentEnd.ID, assignmentEnd).then(() =>
        loadCollegas(false)
      );
    }

    if (task.type == "task") {
      const taskAssignmentStart = taskAssignments.find(
        (x) => x.ID == task.assignmentID
      );

      //console.warn(taskAssignmentStart)

      const taskAssignmentEnd = {
        ID: taskAssignmentStart.ID,
        collegaID: columns.find(
          (c) => c.collegaID === parseInt(destination.droppableId, 10)
        ).collegaID,
        comment: taskAssignmentStart.comment,
        programmeID: taskAssignmentStart.programmeID,
        percentageOverride: taskAssignmentStart.percentageOverride,
        taskID: taskAssignmentStart.taskID,
      };

      //console.warn(taskAssignmentStart, taskAssignmentEnd);

      api.updateTaskAssignment(taskAssignmentEnd.ID, taskAssignmentEnd).then(() =>
        loadCollegas(false)
      );
    }

    /*
    console.log("COLUMS", columns);
    const start = columns.find(
      (c) => c.collegaID === parseInt(source.droppableId, 10)
    );
    const finish = columns.find(
      (c) => c.collegaID === parseInt(destination.droppableId, 10)
    );
    console.warn("Start:", start);
    console.warn("Finish:", finish);
    if (!start || !finish) {
      console.log("no start or finish", start, finish);
      return;
    }

    if (start.collegaID === finish.collegaID) {
      // same col we will just reorder
      const newTaskIds = Array.from(start.taskIds);

      const swapTask = newTaskIds[source.index];
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, swapTask);

      setColumns(
        columns.map((c) => {
          if (c.id === start.id) {
            c.taskIds = newTaskIds;
          }
          return c;
        })
      );
    } else if (finish.taskIds.length < finish.limit) {
      // moved task to another col
      const startTaskIds = Array.from(start.taskIds);
      const [item] = startTaskIds.splice(source.index, 1);

      const finishTaskIds = Array.from(finish.taskIds);
      finishTaskIds.splice(destination.index, 0, item);

      let newColumnsState = columns.map((c) => {
        if (c.collegaID === start.collegaID) {
          c.taskIds = startTaskIds;
        } else if (c.collegaID === finish.collegaID) {
          c.taskIds = finishTaskIds;
        }
        return c;
      });
      console.log("New column state:", newColumnsState);

      const newData = getNewKanbanAssignment(
        newColumnsState,
        olaAssignments,
        taskAssignments
      );
      // update col data
      newColumnsState = columns.map((c) => {
        if (
          c.collegaID === start.collegaID ||
          c.collegaID === finish.collegaID
        ) {
          c.contactHoursQ1 = getContactHours(
            c.collega[0],
            newData.olaAssignments,
            1
          );
          c.contactHoursQ2 = getContactHours(
            c.collega[0],
            newData.olaAssignments,
            2
          );
          c.contactHoursQ3 = getContactHours(
            c.collega[0],
            newData.olaAssignments,
            3
          );
          c.contactHoursQ4 = getContactHours(
            c.collega[0],
            newData.olaAssignments,
            4
          );
          c.currentVTE = calculateRoundedCollegaVTEPreFetched(
            c.collega[0],
            newData.olaAssignments,
            newData.taskAssignments,
            parallels,
            olaAssignments,
            parameters.general,
            parameters.cs,
            parameters.ects
          );
          c.filteredVTE = getVTEForCollegaByProgrammes(
            c.collega[0],
            newData.olaAssignments,
            newData.taskAssignments,
            parallels,
            olaAssignments,
            parameters.general,
            parameters.cs,
            parameters.ects,
            c.collega[0].filteredProgrammes
          );
        }
        return c;
      });

      setColumns(newColumnsState);
      
    }*/
  };

  const openModal = (data) => {
    const columnId = data.id;
    setModal(columnId);
  };

  const closeModal = () => {
    setModal(false);
  };
  /*
    const addTask = (newTask) => {
      setModal(false);
      const updatedColumns = columns.map((column) => {
        if (column.id === newTask.idColumn && column.taskIds.length < 5) {
          column.taskIds.push(newTask);
          return column;
        }
        return column;
      });
      setColumns(updatedColumns);
    };
  
    const removeTask = (taskId) => {
      const updatedColumns = columns
        .map((column) => ({
          ...column,
          taskIds: column.taskIds.filter((task) => task.id !== taskId),
        }))
        .filter((column) => column.taskIds.length >= 0);
      setColumns(updatedColumns);
    };
  
    const editTask = (taskId, newUser, newText) => {
      const updatedColumns = columns.map((column) => ({
        ...column,
        taskIds: column.taskIds.map((task) => {
          if (task.id === taskId) {
            task.user = newUser;
            task.text = newText;
            return task;
          }
          return task;
        }),
      }));
      setColumns(updatedColumns);
    };
  
    const save = async () => {
      try {
        setLoading(true);
  
        const originalAssignments = JSON.parse(originalData.assignments);
        const originalTaskAssignments = JSON.parse(originalData.taskAssignments);
        await saveChanges(columns, originalAssignments, originalTaskAssignments);
        //api.createSnapshot();
  
        // reload assignments
        const assignments = await api.getAssignments(snapshot);
        setOlaAssignments(assignments);
  
        const taskAssignmentsFromAPI = await api.getTaskAssignments(snapshot);
        setTaskAssignments(taskAssignmentsFromAPI);
  
        setOriginalData({
          assignments: JSON.stringify(assignments),
          taskAssignments: JSON.stringify(taskAssignmentsFromAPI),
        });
  
        setLoading(false);
      } catch (error) {
        console.log("error saving", error);
        toastService.send({ title: "An error occured", message: error });
      }
    };
  */
  useEffect(() => {
    // check if SAT-PersonalProgrammeFilter exists in local storage - if not: create it to avoid null reference
    if (!localStorage.getItem("SAT-PersonalProgrammeFilter")) {
      localStorage.setItem(
        "SAT-PersonalProgrammeFilter",
        JSON.stringify([])
      );
    }
    localStorage.setItem(
      "SAT-selectedCollegas",
      JSON.stringify(selectedCollegas)
    );
    loadCollegas();
  }, [snapshot]);

  useEffect(() => {
    loadCollegas(false);
    /*if (selectedCollegas.length === 0) {
      setColumns(
        columns.map((column) => {
          column.show = !(
            column.filteredProgrammesLength > 0 &&
            column.percentageAvailableFiltered === 0
          );
          setLoadingLight(false);
          return column;
        })
      );

      localStorage.setItem(
        "SAT-selectedCollegas",
        JSON.stringify(selectedCollegas)
      );
      setLoadingLight(false);

      return;
    }
    setColumns(
      columns.map((column) => {
        if (
          selectedCollegas.filter((collega) => collega.ID === column.id)
            .length > 0
        ) {
          column.show = true;
        } else {
          column.show = false;
        }

        localStorage.setItem(
          "SAT-selectedCollegas",
          JSON.stringify(selectedCollegas)
        );
        setLoadingLight(false);

        return column;
      })
    );*/
  }, [selectedCollegas]);

  const popover = () => (
    <Popover>
      <Popover.Header as="h3">Filteren</Popover.Header>
      <Popover.Body>
        <h5>Docenten</h5>
        <MultiSelect
          options={collegas}
          value={selectedCollegas}
          onChange={setSelectedCollegas}
          labelledBy="Select"
          className="docenten-selector"
        />
      </Popover.Body>
    </Popover>
  );

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }

  return (
    <>
      {loadingLight &&
        <div className="loading-light">
          <div className="spin-center">
            <i className="fad fa-spinner-third fa-spin fa-5x" />
            <p>Data aan het verwerken</p>
          </div>
        </div>
      }
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="Kanban">
          {modal && (
            <KanbanModal
              closeModal={closeModal}
              addTask={addTask}
              columnData={modal}
            />
          )}

          <div className="float-end fixedElement">
            <OverlayTrigger
              trigger="click"
              placement="left"
              overlay={popover()}
            >
              <Button variant="secondary" className="me-2">
                <i className="far fa-filter" />
              </Button>
            </OverlayTrigger>
            {/*<Button variant="success" onClick={save} disabled={snapshot}>
              <i className="far fa-save" />
              &nbsp;Opslaan
            </Button>*/}
          </div>

          <div className="Kanban-columns-container">
            {columns.map((c) => (
              <KanbanColumn
                columnData={c}
                key={c.name}
              />
            ))}
          </div>
        </div>
      </DragDropContext>
    </>
  );
}

export default Kanban;
